"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRetries = withRetries;
/**
 * Retry a function a number of times before giving up.
 * @param fn Function to be called. The function will be called at least once and retried up to a number times that is given by options.retryAttempts.
 * @param logger Logger to use for logging.
 * @param options Options for retrying.
 * @returns Result of the function.
 */
async function withRetries(fn, logger, options) {
    const { retryAttempts, delayMs } = options;
    // attempt to call the function and retry as many times as given by retryAttempts after initial call fails
    for (let attempt = 0; attempt <= retryAttempts; attempt++) {
        try {
            return await fn();
        }
        catch (error) {
            if (attempt === retryAttempts) {
                throw error;
            }
            logger.log({
                message: `Retrying ${attempt + 1} of ${retryAttempts}...`,
                payload: {
                    error,
                },
            });
            // wait before next retry
            // eslint-disable-next-line @typescript-eslint/no-loop-func
            await new Promise((resolve) => setTimeout(resolve, delayMs));
        }
    }
    // Note: this should never happen unless a bug introduced in the catch branch above
    throw new Error("Unhandled state after attempts exhausted.");
}
//# sourceMappingURL=withRetries.js.map